var _linearGradient, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1063.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "hr-customer-service-mobile--lg-1",
    x1: 689.073,
    x2: 415.244,
    y1: 114.4017,
    y2: 882.3134,
    gradientTransform: "matrix(1 0 0 -1 0 1064)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b17ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098aed"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#098aed",
    d: "M796 918.2c-12.6 22.8-33.9 39.7-59.5 46.5l-355 95.2c-33.4 8.9-68.9-.6-93.4-25.1L28.4 775.1c-24.7-24.5-34.1-60-25.1-93.4l3-11.4.6 1.2-.3-.9 46.5-174.5.2-.1 45.2-168.9c9.1-33.7 35.1-59.7 68.5-68.6l89.6-24-27.1 101.1-.1.2L183 510.4l.3.9c-.2-.4-.4-.8-.6-1.3l-3.1 11.4c-8.8 33.4.6 68.9 25.1 93.5l259.7 259.7c24.6 24.5 60.1 34 93.5 25.1l182.3-48.9 55.8 67.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hr-customer-service-mobile--lg-1)",
    d: "M900.4 542.1l-35.6 132.5-.1.6-15.8 58.5-.2.1L821 836.3l-16 59.8c-2.1 7.8-5.2 15.1-9 22l-55.8-67.5-182.3 48.9c-33.4 8.8-68.9-.7-93.5-25.1L204.7 614.8c-24.6-24.6-34-60.1-25.1-93.5l3.1-11.4c.2.5.4.9.6 1.3l-.3-.9 46.5-174.5.1-.2 27.1-101.1 265.4-71c33.3-8.8 68.8.6 93.4 25.1l260 259.7c24.2 24.5 33.9 60 24.9 93.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#41d3bd",
    d: "M1076.7 381.8l-153.8 621.1c-5 20.6-30.1 28.4-45.9 14.5l-81-99.2c3.8-6.9 6.9-14.3 9-22l16-59.8 27.6-102.5.2-.1 15.8-58.5.1-.6 35.6-132.5c9-33.8-.7-69.3-24.9-93.8l-260-259.7c-24.6-24.6-60.1-34-93.4-25.1l-265.4 71 18.2-67.8c9.2-33.7 35.2-59.7 68.6-68.5l354.9-95c33.4-8.8 68.9.6 93.4 25.1l260 259.7c24.3 24.4 34 60 25 93.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerService);
export default __webpack_public_path__ + "static/media/customer-service.a1a53aeb.svg";
export { ForwardRef as ReactComponent };